// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { PaginationMeta, PaginationMetaT, verifyPaginationMeta } from "./pagination-meta";
import { LeadingZeroes, LeadingZeroesT, verifyLeadingZeroes } from "../archive/leading-zeroes";

/**
 * Paginated response for leading zeroes.
 */
export class PaginatedLeadingZeroes implements flatbuffers.IUnpackableObject<PaginatedLeadingZeroesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PaginatedLeadingZeroes {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPaginatedLeadingZeroes(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedLeadingZeroes,
  ): PaginatedLeadingZeroes {
    return (obj || new PaginatedLeadingZeroes()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsPaginatedLeadingZeroes(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginatedLeadingZeroes,
  ): PaginatedLeadingZeroes {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PaginatedLeadingZeroes()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  meta(obj?: PaginationMeta): PaginationMeta | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new PaginationMeta()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  data(index: number, obj?: LeadingZeroes): LeadingZeroes | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new LeadingZeroes()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  dataLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startPaginatedLeadingZeroes(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMeta(builder: flatbuffers.Builder, metaOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, metaOffset, 0);
  }

  static addData(builder: flatbuffers.Builder, dataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, dataOffset, 0);
  }

  static createDataVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startDataVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endPaginatedLeadingZeroes(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPaginatedLeadingZeroes(
    builder: flatbuffers.Builder,
    metaOffset: flatbuffers.Offset,
    dataOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    PaginatedLeadingZeroes.startPaginatedLeadingZeroes(builder);
    PaginatedLeadingZeroes.addMeta(builder, metaOffset);
    PaginatedLeadingZeroes.addData(builder, dataOffset);
    return PaginatedLeadingZeroes.endPaginatedLeadingZeroes(builder);
  }

  unpack(): PaginatedLeadingZeroesT {
    return new PaginatedLeadingZeroesT(
      this.meta() !== null ? this.meta()!.unpack() : null,
      this.bb!.createObjList<LeadingZeroes, LeadingZeroesT>(
        this.data.bind(this),
        this.dataLength(),
      ),
    );
  }

  unpackTo(_o: PaginatedLeadingZeroesT): void {
    _o.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    _o.data = this.bb!.createObjList<LeadingZeroes, LeadingZeroesT>(
      this.data.bind(this),
      this.dataLength(),
    );
  }

  unpackFields(...fields: string[]): PaginatedLeadingZeroesT {
    const t = new PaginatedLeadingZeroesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("meta")) {
      t.meta = this.meta() !== null ? this.meta()!.unpack() : null;
    }
    if (fieldSet.has("data")) {
      t.data = this.bb!.createObjList<LeadingZeroes, LeadingZeroesT>(
        this.data.bind(this),
        this.dataLength(),
      );
    }
    return t;
  }
}

export class PaginatedLeadingZeroesT implements flatbuffers.IGeneratedObject {
  constructor(
    public meta: PaginationMetaT | null = null,
    public data: LeadingZeroesT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const meta = this.meta !== null ? this.meta!.pack(builder) : 0;
    const data = PaginatedLeadingZeroes.createDataVector(
      builder,
      builder.createObjectOffsetList(this.data),
    );

    return PaginatedLeadingZeroes.createPaginatedLeadingZeroes(builder, meta, data);
  }

  clone(): PaginatedLeadingZeroesT {
    const obj = new PaginatedLeadingZeroesT();
    obj.meta = this.meta !== null ? this.meta!.clone() : null;
    obj.data = this.data.map((e) => e.clone());
    return obj;
  }

  equals(other: PaginatedLeadingZeroesT): boolean {
    if (this.meta !== null && other.meta !== null) {
      if (!this.meta!.equals(other.meta!)) return false;
    } else if (this.meta !== other.meta) return false;
    if (this.data.length !== other.data.length) return false;
    for (let i = 0; i < this.data.length; i++) {
      const a = this.data[i];
      const b = other.data[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyPaginatedLeadingZeroes(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyPaginationMeta(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLeadingZeroes);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
